import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

export default function ModalInfo(props) {

  const [modal, setModal] = useState(true);

  const toggle = () => setModal(!modal);

  return (
    <div>
      <Button
        style={{
          backgroundColor: "transparent",
          color: "transparent",
          border: "transparent",
          paddingLeft: 0,
        }}
        // onClick={toggle}
      >
      </Button>

      <Modal size={"md"} centered={true} isOpen={modal} toggle={toggle}>
        <ModalHeader style={{ backgroundColor: "#CED8D7" }} toggle={toggle}>
          {props.ModalTitle}
        </ModalHeader>
        <ModalBody>{props.ModalBody}</ModalBody>
        <ModalFooter style={{ backgroundColor: "#CED8D7" }}>
          <br></br>
        </ModalFooter>
      </Modal>
    </div>
  );
}
